<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
    <circle cx="15" cy="15" r="14" fill="#3CA300" stroke="#fff" stroke-width="2"/>
    <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M8 15.5l4.014 4.5 9.486-9"/>
</svg>
